import {
  SYNC_RUN_STATUS_RUNNING,
  SYNC_RUN_STATUS_STARTING,
  WORKER_JOB_NAME_COORDINATOR,
  WORKER_JOB_CONTROL_STOP_ALL_DONT_START,
} from 'redux/constants'

export const isWorkerJobRunning = (workerJob) =>
  workerJob.runStatus === SYNC_RUN_STATUS_RUNNING || workerJob.runStatus === SYNC_RUN_STATUS_STARTING

export const getRunningWorkerJobs = (workerJobs) =>
  (workerJobs || []).filter(job => job.name !== WORKER_JOB_NAME_COORDINATOR && isWorkerJobRunning(job))

export const isStopAllWorkerJobsRequested = (workerJobs) => {
  const coordinator = (workerJobs || []).find(job => job.name === WORKER_JOB_NAME_COORDINATOR)
  return !!coordinator && coordinator.controlSignal === WORKER_JOB_CONTROL_STOP_ALL_DONT_START
}
